/**
 * Org-wide admins (superadmin, orgadmin, orgbruger): all locations.
 * Uddansvarlig: only stations returned by GET /users/locations for that role.
 * Uddassistent and other roles: no access to DUNA stats / profile navigation on location lists.
 */
export function userCanViewUserGroupsLocation(params: {
  userRoles: string[];
  locationGuid: string | null;
  userLocationGuids: string[];
}): boolean {
  const { userRoles, locationGuid, userLocationGuids } = params;

  if (
    userRoles.includes('superadmin') ||
    userRoles.includes('orgadmin') ||
    userRoles.includes('orgbruger')
  ) {
    return true;
  }

  if (!userRoles.includes('uddansvarlig') || !locationGuid) {
    return false;
  }

  return userLocationGuids.includes(locationGuid);
}
